const IF = ({ condition, children, ELSE = <></> }) => {
  return condition ? children : ELSE;
};

export default IF;
